function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { IconedButton } from '.';
export function DownloadButton(_ref) {
  let {
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(IconedButton, _extends({
    icon: "download"
  }, props));
}
;